export default __webpack_public_path__ + "static/media/logo_scania_bco.7971af20.png";